import React, { useState, useEffect } from 'react'
import Tooltip from '@tippyjs/react';

import { getTrans as t } from "../../Localization/translations"
import PartyAddessFiled from './PartyAddessFiled';
import ConractAddExtraFiled from './ContractAddExtraFiled';
import AssetsAddExtraFiled from './AssetsAddExtraFiled';
import InvoiceHeaderAddExtraFiled from './InvoiceHeaderAddExtraFiled';
import ReceiptAddExtraFiled from './ReceiptAddExtraFiled';
import PartyFiled from './PartyAddExtraFiled';
import PaymentExtraFiled from './paymentExtrafiled';


function EditExtrafileds() {

const [selcetform, setSelectForm] = useState("")
const [asset, setAsset] = useState(false)
const [invoice, setInvoice] = useState(false)
const [receipt, setReceipt] = useState(false)
const [payment, setPayment] = useState(false)
const [partyselect, setPartySelect] = useState(false)
const [contractselect, setContractSelect] = useState(false)
const [partyaddress, setPartyAddress] = useState(false)

useEffect(() => {
    selcetform === 'Contract' ?
        setContractSelect(true) : setContractSelect(false);

    selcetform === 'Party' ?
        setPartySelect(true) : setPartySelect(false);

    selcetform === 'PartyAddress' ?
        setPartyAddress(true) && setPartyAddress("PartyAddress") : setPartyAddress(false)

    selcetform === 'ContractAsset' ?
        setAsset(true) : setAsset(false)

    selcetform === 'Invoice' ?
        setInvoice(true) : setInvoice(false)

    selcetform === 'Receipt' ?
        setReceipt(true) : setReceipt(false)

    selcetform === 'Payment' ?
        setPayment(true) : setPayment(false)

}, [selcetform])


const handleClick = (e) => {
    setSelectForm(e.target.value)
}

return (
<>
<div className="container-fluid">
    <div className="">
        <div className="header pb-0">
            <div className="d-lg-flex">
                <div>
                    <h5 className="mb-3 mt-3">{t("Additional Information")}</h5>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div className="card" role="document">
        <div className="card-body">
            <div className="row">
                <div className="col-md-2 mb-3" >
                    <label className="col-form-label ">
                        {t('Select Form')} <Tooltip content={t('SelectFormfor_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip>
                    </label>
                    <select
                        value={selcetform}
                        onChange={handleClick}
                        id="trade_in_payto" className="form-control form-select">
                        <option value="">{t("Select")}</option>
                        <option value="Party" >{t("Party")}</option>
                        <option value="PartyAddress" >{t("PartyAddress")}</option>
                        <option value="Contract" >{t("Contract")}</option>
                        <option value="ContractAsset" >{t("Asset")}</option>
                        <option value="Invoice" >{t("Invoice")}</option>
                        <option value="Receipt" >{t("Receipt")}</option>
                        <option value="Payment" >{t("Payment")}</option>
                    </select>
                </div>
            </div>
                { partyselect && <PartyFiled/> }

                {contractselect && <ConractAddExtraFiled />}

                {partyaddress && <PartyAddessFiled />}
                
                {asset && <AssetsAddExtraFiled />}
                
                {invoice && <InvoiceHeaderAddExtraFiled />}

                {receipt && <ReceiptAddExtraFiled />}
                
                {payment && <PaymentExtraFiled />}
        </div>
    </div>
</div>
</>
)
}

export default EditExtrafileds
